import { ConfigurationMapper } from './ConfigurationMapper.js';

class ConfigurationRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getAllConfigurations() {
    return this.apiClient.get('/v1/import/configurations').then(response => ConfigurationMapper.getAllConfigurationsModelFromResponse(response.data));
  }
  createConfiguration(configuration) {
    return this.apiClient.post(`/v1/import/configurations/${configuration.integration}`, ConfigurationMapper.createPayload(configuration)).then(response => response.data);
  }
  updateConfiguration(configuration) {
    return this.apiClient.patch(`/v1/import/configurations/integration/${configuration.identifier}`, ConfigurationMapper.updatePayload(configuration)).then(response => response.data);
  }
  deleteConfiguration(id) {
    return this.apiClient.delete(`/v1/import/configurations/${id}`).then(response => response.data);
  }
}

export { ConfigurationRepository };
//# sourceMappingURL=ConfigurationRepository.js.map
